import axios from 'axios';

import { headers, STOCK } from '../../config';

export function searchWarehouse(data) {
    return axios.get(`${STOCK}/warehouses-search`, { headers: headers(), params: {
        search: data
    } })
}

export function getWarehouse({id}) {
    return axios.get(`${STOCK}/warehouses/${id}`, { headers: headers() })
}

export function createWarehouse(data, idempotentKey) {
    return axios.post(`${STOCK}/warehouses`, data, { headers: {...headers(), "X-Request-ID": idempotentKey} });
}

export function updateWarehouse(data) {
    return axios.put(`${STOCK}/warehouses/${data.id}`, data, {headers: headers()})
}

export function deleteWarehouse({id}) {
    return axios.delete(`${STOCK}/warehouses/${id}`, {headers: headers()})
}

export default {
    searchWarehouse,
    getWarehouse,
    createWarehouse,
    updateWarehouse,
    deleteWarehouse
}